@if(wizardStore.I().form; as formGroup){
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-validated-textarea
      [label]="translationKey + 'lenderInformation'"
      inputFormControlName="lenderInformation"
      [inputFormControl]="formGroup.controls.lenderInformation"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'loanRatesRange'"
      inputFormControlName="loanRatesRange"
      [inputFormControl]="formGroup.controls.loanRatesRange"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'riskDistribution'"
      inputFormControlName="riskDistribution"
      [inputFormControl]="formGroup.controls.riskDistribution"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'internalMethodology'"
      inputFormControlName="internalMethodology"
      [inputFormControl]="formGroup.controls.internalMethodology"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'confidenceRate'"
      inputFormControlName="confidenceRate"
      [inputFormControl]="formGroup.controls.confidenceRate"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'creditPortfolioSelection'"
      inputFormControlName="creditPortfolioSelection"
      [inputFormControl]="formGroup.controls.creditPortfolioSelection"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'capitalGuarantees'"
      inputFormControlName="capitalGuarantees"
      [inputFormControl]="formGroup.controls.capitalGuarantees"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'defaultStrategy'"
      inputFormControlName="defaultStrategy"
      [inputFormControl]="formGroup.controls.defaultStrategy"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'riskSharing'"
      inputFormControlName="riskSharing"
      [inputFormControl]="formGroup.controls.riskSharing"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'feesAndCharges'"
      inputFormControlName="feesAndCharges"
      [inputFormControl]="formGroup.controls.feesAndCharges"
      [rows]="10"
      [maxLength]="2000"
    />
  </app-card>
</form>

}
